// Стрелка-иконка: одна и та же фигура в обе стороны (текстовые ← и → в шрифтах разные по ширине и толщине)
export default function Arrow({ dir }: { dir: "left" | "right" }) {
  return (
    <svg className="arrow-ico" viewBox="0 0 24 24" aria-hidden="true" style={dir === "left" ? { transform: "scaleX(-1)" } : undefined}>
      <path d="M4 12h15M13 6l6 6-6 6" />
    </svg>
  );
}
